import loadingImage from "../assets/ToronQ_Full_Logo.png";

const Loader = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-[#081124] via-[#0B1730] to-[#0222F1]/40 px-6">
      <div className="flex flex-col items-center gap-7">
        <div className="relative flex h-44 w-44 items-center justify-center sm:h-56 sm:w-56">
          <div className="absolute inset-0 animate-spin rounded-full border-4 border-white/10 border-t-[#0222F1]" />

          <div className="relative flex h-36 w-36 items-center justify-center sm:h-44 sm:w-44">
            <img
              src={loadingImage}
              alt="ToronQ AI"
              className="h-full w-full object-contain drop-shadow-xl"
            />
          </div>
        </div>

        <div className="text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-white/80">
            ToronQ AI
          </p>
          <p className="mt-2 text-sm text-white/60">Loading admin console...</p>
        </div>
      </div>
    </div>
  );
};

export default Loader;
